var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4209 5.17217C23.0369 2.46079 26.9635 2.46079 28.5794 5.17218L44.3397 31.6167C45.9949 34.3941 43.9936 37.9165 40.7604 37.9165H9.2399C6.00669 37.9165 4.00542 34.3941 5.66067 31.6167L21.4209 5.17217Z",
    fill: "#FF515B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1708 14.3761C22.1069 12.7702 23.3909 11.4331 24.9981 11.4321C26.6067 11.431 27.893 12.7687 27.8291 14.376L27.4541 23.8087C27.4017 25.1268 26.3173 26.1681 24.998 26.1671C23.6804 26.166 22.5984 25.1253 22.546 23.8087L22.1708 14.3761Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.94625,
    cy: 2.94625,
    r: 2.94625,
    transform: "matrix(0.707113 0.707101 -0.707113 0.707101 25 27.79)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorChain);
export default __webpack_public_path__ + "static/media/error_chain.bb6af56d84dba065804829a4b881380b.svg";
export { ForwardRef as ReactComponent };